import { render, staticRenderFns } from "./DistributionWidget.vue?vue&type=template&id=8b86e804&scoped=true&"
import script from "./DistributionWidget.vue?vue&type=script&lang=js&"
export * from "./DistributionWidget.vue?vue&type=script&lang=js&"
import style0 from "./DistributionWidget.vue?vue&type=style&index=0&id=8b86e804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b86e804",
  null
  
)

export default component.exports